import { cn } from "@/lib/utils"

type ChartContainerProps = React.HTMLAttributes<HTMLDivElement>

export function ChartContainer({ className, ...props }: ChartContainerProps) {
  return (
    <div 
      className={cn("w-full h-[300px]", className)} 
      {...props} 
    />
  )
}